import React, { useState } from 'react';
import { Award, CheckCircle, TrendingUp } from 'lucide-react';
import AppraisalCycles from './appraisal/AppraisalCycles';
import ApprovalQueue from './appraisal/ApprovalQueue';
import AppraisalReports from './appraisal/AppraisalReports';

const AppraisalManagement = () => {
  const [activeTab, setActiveTab] = useState('cycles');

  const tabs = [
    { id: 'cycles', label: 'Appraisal Cycles', icon: Award, desc: 'Performance Cycles' },
    { id: 'approvals', label: 'Approval Queue', icon: CheckCircle, desc: 'Compensation Review' },
    { id: 'reports', label: 'Appraisal Reports', icon: TrendingUp, desc: 'Analytics & Insights' },
  ];

  return (
    <div className="min-h-screen bg-slate-50 font-roboto">
      <div className="p-6 max-w-7xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-black font-poppins text-slate-900 tracking-tight">
            Appraisal <span className="text-indigo-600">Management</span>
          </h1>
          <div className="h-1 w-12 bg-indigo-600 mt-1 rounded-full" />
        </div>

        <div className="flex gap-2 mb-6 overflow-x-auto">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-6 py-3 rounded-lg text-sm font-bold whitespace-nowrap transition ${
                  activeTab === tab.id
                    ? 'bg-indigo-600 text-white shadow-lg'
                    : 'bg-white text-slate-600 hover:bg-slate-100 border border-slate-200'
                }`}
              >
                <Icon size={18} />
                <div className="text-left">
                  <div>{tab.label}</div>
                  <div className="text-[10px] font-normal opacity-80">{tab.desc}</div>
                </div>
              </button>
            );
          })}
        </div>

        <div>
          {activeTab === 'cycles' && <AppraisalCycles />}
          {activeTab === 'approvals' && <ApprovalQueue />}
          {activeTab === 'reports' && <AppraisalReports />}
        </div>
      </div>
    </div>
  );
};

export default AppraisalManagement;
